import React from 'react'
import Mobile from './Mobile'
import Desktop from './Desktop'
import { IMenuDropdown } from './typing'

const MenuDropdown: React.FC<IMenuDropdown> = ({ mobile, anchorEl, ...rest }) =>
  mobile ? <Mobile {...rest} /> : <Desktop anchorEl={anchorEl} {...rest} />

export default MenuDropdown
